.page {
  max-width: 1120px;
  padding: 0 26px 30px;
}

/* ---- search ---- */

.searchCard {
  margin-bottom: 16px;
  padding: 18px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: linear-gradient(180deg, var(--paper-raised), var(--paper));
}

.search {
  display: flex;
  gap: 8px;
}

.field {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.field svg {
  position: absolute;
  top: 50%;
  left: 14px;
  width: 17px;
  height: 17px;
  transform: translateY(-50%);
  fill: none;
  stroke: var(--ink-muted);
  stroke-width: 1.8;
  stroke-linecap: round;
  pointer-events: none;
}

.field input {
  width: 100%;
  height: 46px;
  padding: 0 14px 0 40px;
  border: 1px solid var(--line-strong);
  border-radius: 10px;
  background: var(--paper);
  color: var(--ink);
  font: inherit;
  font-size: 14px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.field input::placeholder {
  color: var(--ink-muted);
}

.field input:focus {
  border-color: var(--signal);
  outline: none;
  box-shadow: 0 0 0 3px var(--signal-soft);
}

.field input[aria-invalid="true"] {
  border-color: var(--down);
}

.search > button {
  flex: none;
  height: 46px;
  padding: 0 22px;
  border: 0;
  border-radius: 10px;
  background: var(--signal-fill);
  color: var(--ink);
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
}

.search > button:hover {
  filter: brightness(1.12);
}

.options {
  position: absolute;
  z-index: 10;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  margin: 0;
  padding: 4px;
  border: 1px solid var(--line-strong);
  border-radius: 10px;
  background: var(--paper-raised);
  box-shadow: 0 12px 32px rgb(0 0 0 / 45%);
  list-style: none;
}

.options li {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 7px;
  cursor: pointer;
}

.options li[aria-selected="true"],
.options li:hover {
  background: var(--signal-soft);
}

.options strong {
  min-width: 56px;
  font: 700 12.5px var(--mono);
}

.options span {
  overflow: hidden;
  color: var(--ink-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popular {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
}

.popular span {
  margin-right: 2px;
  color: var(--ink-muted);
  font: 9px var(--mono);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.popular button {
  min-height: 26px;
  padding: 0 10px;
  border: 1px solid var(--line-strong);
  border-radius: 13px;
  background: transparent;
  color: var(--ink-muted);
  cursor: pointer;
  font: 600 11px var(--mono);
}

.popular button:hover,
.popular button[aria-pressed="true"] {
  border-color: var(--signal);
  color: var(--ink);
}

.range {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.custom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.custom label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ink-muted);
  font: 10px var(--mono);
  text-transform: uppercase;
}

.custom input {
  height: 28px;
  padding: 0 8px;
  border: 1px solid var(--line-strong);
  border-radius: 6px;
  background: var(--paper);
  color: var(--ink);
  color-scheme: dark;
  font: 12px var(--mono);
}

.custom button {
  height: 28px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: var(--signal-fill);
  color: var(--ink);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
}

.custom button:disabled {
  cursor: default;
  opacity: 0.45;
}

.invalidInline {
  color: var(--down);
  font-size: 11px;
}

.priceNote {
  margin: 0 0 6px;
  color: var(--ink-muted);
  font: 10.5px var(--mono);
}

.invalid {
  margin: 10px 0 0;
  color: var(--down);
  font-size: 12px;
}

.empty {
  padding: 48px 16px;
  text-align: center;
}

.empty h2 {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
}

.empty p {
  max-width: 520px;
  margin: 0 auto;
  color: var(--ink-muted);
  font-size: 13px;
  line-height: 1.5;
}

/* ---- loading ---- */

.loading {
  display: grid;
  justify-items: center;
  gap: 14px;
  padding: 64px 0;
}

.loading p {
  margin: 0;
}

.loadingTitle {
  font-size: 14px;
  font-weight: 600;
}

.loadingClock {
  color: var(--signal);
  font: 700 22px var(--mono);
  font-variant-numeric: tabular-nums;
}

.loadingHint {
  max-width: 440px;
  color: var(--ink-muted);
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}

.spinner {
  position: relative;
  display: inline-block;
  flex: none;
}

.spinner i {
  position: absolute;
  top: 0;
  left: 45%;
  width: 10%;
  height: 28%;
  border-radius: 999px;
  background: var(--ink);
  transform-origin: 50% 178%;
  animation: spoke 1s linear infinite;
}

@keyframes spoke {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.15;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner i {
    animation-duration: 3s;
  }
}

/* ---- result ---- */

.panel {
  padding: 18px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--paper-raised);
}

.panelHead {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 16px;
}

.panelHead h2 {
  margin: 0;
  font: 700 24px var(--mono);
  letter-spacing: -0.02em;
}

.issuer {
  margin: 2px 0 0;
  color: var(--ink-muted);
  font-size: 13px;
}

.quote {
  display: grid;
  justify-items: end;
  gap: 2px;
}

.quote strong {
  font: 700 20px var(--mono);
}

.quote span {
  color: var(--ink-muted);
  font: 10.5px var(--mono);
}

.badge {
  margin-left: 10px;
  padding: 2px 7px;
  border: 1px solid var(--caution-line);
  border-radius: 5px;
  background: var(--caution-fill);
  color: var(--caution);
  font: 600 9px var(--mono);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: 5px;
}

.progress {
  margin: 14px 0;
  padding: 14px 16px 12px;
  border: 1px solid var(--line-strong);
  border-radius: 10px;
  background: linear-gradient(180deg, var(--signal-soft), transparent 70%), var(--paper);
}

.progress[data-done="true"] {
  border-color: var(--line);
  background: var(--paper);
}

.progressHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin-bottom: 12px;
}

.progressHead strong {
  font-size: 13px;
  font-weight: 600;
}

.check {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--up);
  color: var(--paper);
  font-size: 11px;
  font-weight: 800;
}

.timer {
  margin-left: auto;
  color: var(--ink-muted);
  font: 11.5px var(--mono);
  font-variant-numeric: tabular-nums;
}

.timer b {
  color: var(--ink);
  font-weight: 700;
}

.track {
  position: relative;
  height: 10px;
  overflow: hidden;
  border-radius: 5px;
  background: var(--line);
}

.track i {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 5px;
  background: linear-gradient(90deg, var(--signal-fill), var(--signal), var(--signal-fill));
  background-size: 200% 100%;
  transition: width 0.6s ease-out;
}

.track s {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--paper);
  opacity: 0.7;
}

@media (prefers-reduced-motion: no-preference) {
  .progress:not([data-done="true"]) .track i {
    animation: shimmer 1.6s linear infinite;
  }
}

@keyframes shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: 0 0;
  }
}

.progress[data-done="true"] .track i {
  background: var(--up);
}

.years {
  position: relative;
  height: 16px;
  margin-top: 4px;
  font: 9.5px var(--mono);
}

.years span {
  position: absolute;
  transform: translateX(-50%);
  color: var(--ink-muted);
  opacity: 0.55;
  transition: opacity 0.3s, color 0.3s;
}

.years span[data-reached="true"] {
  color: var(--ink);
  opacity: 1;
}

.progressStats {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 16px;
  color: var(--ink-muted);
  font: 11px var(--mono);
}

.progressStats b {
  color: var(--ink);
  font-weight: 700;
}

.percent {
  margin-left: auto;
  color: var(--signal);
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.progress[data-done="true"] .percent {
  color: var(--up);
}

.throttled {
  margin: 8px 0 0;
  color: var(--caution);
  font-size: 11px;
}

.errorInline {
  margin: 8px 0 0;
  color: var(--down);
  font-size: 11px;
}

.tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 14px;
}

.tiles div {
  display: grid;
  gap: 3px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: var(--paper);
}

.tiles span {
  color: var(--ink-muted);
  font: 9px var(--mono);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.tiles strong {
  font: 700 19px var(--mono);
}

.tiles small {
  color: var(--ink-muted);
  font: 10px var(--mono);
}

@media (max-width: 640px) {
  .tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.up {
  color: var(--up);
}

.down {
  color: var(--down);
}

.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  margin-bottom: 12px;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  border: 0;
}

.chips legend,
.segments > span {
  float: left;
  margin-right: 6px;
  color: var(--ink-muted);
  font: 9px var(--mono);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.chips button {
  min-height: 26px;
  padding: 0 9px;
  border: 1px solid var(--line-strong);
  border-radius: 13px;
  background: transparent;
  color: var(--ink-muted);
  cursor: pointer;
  font: inherit;
  font-size: 11px;
}

.chips button[aria-pressed="true"] {
  border-color: var(--signal);
  background: var(--signal-soft);
  color: var(--ink);
}

.chips button[data-type="purchase"][aria-pressed="true"] {
  border-color: var(--up);
}

.chips button[data-type="sale"][aria-pressed="true"] {
  border-color: var(--down);
}

.segments {
  display: inline-flex;
  align-items: center;
}

.segments button {
  min-height: 26px;
  padding: 0 10px;
  border: 1px solid var(--line-strong);
  background: transparent;
  color: var(--ink-muted);
  cursor: pointer;
  font: 600 10.5px var(--mono);
}

.segments button + button {
  border-left: 0;
}

.segments span + button {
  border-radius: 6px 0 0 6px;
}

.segments button:first-child {
  border-radius: 6px 0 0 6px;
}

.segments button:last-child {
  border-radius: 0 6px 6px 0;
}

.segments button[aria-pressed="true"] {
  background: var(--signal-fill);
  color: var(--ink);
}

.chartBox {
  position: relative;
  padding: 10px 0 0;
  border-top: 1px solid var(--line);
}

.chartBox > .segments {
  position: relative;
  z-index: 2;
  margin-bottom: 6px;
}

.listTitle {
  margin: 18px 0 6px;
  color: var(--ink-muted);
  font: 600 9px var(--mono);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.tableWrap {
  max-height: 60vh;
  overflow: auto;
  border-top: 1px solid var(--line);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.table th {
  position: sticky;
  top: 0;
  padding: 8px 6px;
  background: var(--paper-raised);
  color: var(--ink-muted);
  font: 600 9px var(--mono);
  letter-spacing: 0.06em;
  text-align: left;
  text-transform: uppercase;
}

.table td {
  padding: 8px 6px;
  border-top: 1px solid var(--line);
  vertical-align: top;
}

.table tbody tr:hover {
  background: var(--signal-soft);
}

.table a {
  color: var(--signal);
  font-size: 11px;
  white-space: nowrap;
}

.num {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}

.table th.num {
  text-align: right;
}

.time {
  color: var(--ink-muted);
  font: 11px var(--mono);
  white-space: nowrap;
}

.sub {
  display: block;
  max-width: 240px;
  overflow: hidden;
  color: var(--ink-muted);
  font-size: 10.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type {
  color: var(--ink-muted);
  font-weight: 600;
  white-space: nowrap;
}

.type[data-type="purchase"] {
  color: var(--up);
}

.type[data-type="sale"] {
  color: var(--down);
}

.more {
  display: block;
  margin: 12px auto 0;
  padding: 7px 16px;
  border: 1px solid var(--line-strong);
  border-radius: 8px;
  background: transparent;
  color: var(--signal);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
}

.notice,
.error {
  margin: 0;
  padding: 32px 0;
  color: var(--ink-muted);
  font-size: 13px;
  text-align: center;
}

.error {
  color: var(--down);
}

.footer {
  margin: 16px 0 0;
  color: var(--ink-muted);
  font-size: 10.5px;
  line-height: 1.5;
}

.footer a {
  color: var(--signal);
}

@media (max-width: 640px) {
  .page {
    padding: 0 12px 24px;
  }

  .searchCard,
  .panel {
    padding: 14px;
  }

  .search > button {
    padding: 0 14px;
  }
}

.longLoad {
  margin: 14px 0;
  padding: 14px 16px;
  border: 1px solid var(--caution-line);
  border-radius: 10px;
  background: var(--caution-fill);
}

.longLoad strong {
  color: var(--caution);
  font-size: 13px;
}

.longLoad p {
  margin: 6px 0 12px;
  color: var(--ink);
  font-size: 12.5px;
  line-height: 1.5;
}

.longLoadActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.longLoadActions button {
  min-height: 32px;
  padding: 0 14px;
  border: 1px solid var(--line-strong);
  border-radius: 8px;
  background: transparent;
  color: var(--ink);
  cursor: pointer;
  font: inherit;
  font-size: 12.5px;
}

.longLoadActions .primary {
  border-color: transparent;
  background: var(--signal-fill);
  font-weight: 600;
}
